import { Theme } from './symbols';

export const classicTheme: Theme = {
  name: 'classic',
  properties: {
    '--primary-color': 'rgba(0, 93, 102, 1)',
    '--primary-light': 'rgba(0, 93, 102, 0.1)',
    '--secondary-color': 'rgba(136, 136, 136, 1)',
    '--complementary-color': 'rgba(72, 91, 157, 1)',
  }
};
